import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type IndividualSummary = {
   userid: number;
   image: string;
   name: string;
   courseCount: number;
   assignedCoursesUrl: string;
};

export type GetCourseAssignmentIndividualSummariesRequestOptions = CommonRequestOptions & {
   orderby?: 'name';
   direction?: 'ASC' | 'DESC';
   page?: number;
   pageSize?: number;
   query?: string;
};

export type GetCourseAssignmentIndividuialSummariesResult = {
   individualSummaries: IndividualSummary[];
   hasMore: boolean;
};

export async function getCourseAssignmentIndividualSummaries({
   orderby,
   direction,
   page,
   pageSize,
   query,
   ...common
}: GetCourseAssignmentIndividualSummariesRequestOptions = {}): Promise<GetCourseAssignmentIndividuialSummariesResult> {
   return makeRequest('get', 'course_assignments/individualSummaries', {
      ...common,
      query: {
         orderby,
         direction,
         page,
         pageSize,
         query,
      },
   });
}
